import api from "./Api";
export const isConnectionFailure = e => !e?.response && ['ERR_NETWORK','ECONNABORTED','ETIMEDOUT'].includes(e?.code);
const canceled = () => Object.assign(new Error('Consulta cancelada'),{code:'ERR_CANCELED'});
function pause(ms,signal){return new Promise((resolve,reject)=>{
 if(signal?.aborted){reject(canceled());return;}
 const abort=()=>{clearTimeout(timer);signal?.removeEventListener('abort',abort);reject(canceled());};
 const timer=setTimeout(()=>{signal?.removeEventListener('abort',abort);resolve();},ms);
 signal?.addEventListener('abort',abort,{once:true});
});}
// Only reads: never repeat a command, email, or mutation after an uncertain response.
export default async function readWithRetry(url,config={}){
 for(let attempt=0;attempt<3;attempt++){
  if(config.signal?.aborted)throw canceled();
  try{return await api.get(url,config);}catch(e){
   if(config.signal?.aborted)throw canceled();
   if(!isConnectionFailure(e)||attempt===2)throw e;
   await pause(600*(attempt+1),config.signal);
  }
 }
}
